import { useMemo } from 'react';
import { format } from '../../../utils/date';
import { createHeatmapColorizer } from '../../../utils/heatmap';

const buildYearGroups = (months) =>
  months.reduce((groups, date) => {
    const year = format(date, 'YYYY');
    const last = groups[groups.length - 1];

    if (last && last.year === year) {
      last.count += 1;
    } else {
      groups.push({ year, count: 1 });
    }

    return groups;
  }, []);

export default function useHeatmapConfig({ months, data }) {
  const yearGroups = buildYearGroups(months);
  const lastMonthIndex = months.length - 1;

  const { getBackground } = useMemo(() => {
    const allSeries = data.flatMap((row) => row.values.map((value, i) => [months[i], value]));
    return createHeatmapColorizer(allSeries);
  }, [months, data]);

  return { yearGroups, lastMonthIndex, getBackground };
}
